import styled from 'styled-components';
import { ThemeInterface } from '../../interfaces/themeInterface';

const getOppositeBackground = (theme: ThemeInterface) =>
  theme.name === 'long' ? 'blue' : '#ffccd5';

const getOppositeText = (theme: ThemeInterface) => (theme.name === 'long' ? 'white' : 'black');
const monoStack =
  "'SFMono-Regular', Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace";

export const Wrapper = styled.div`
  position: relative;
`;

export const AccountBtn = styled.button`
  background: ${({ theme }: { theme: ThemeInterface }) =>
    theme.name === 'short'
      ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.13) 0%, rgba(255, 255, 255, 0.05) 100%)'
      : 'linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.04) 100%)'};
  border: 1px solid
    ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short' ? 'rgba(255, 255, 255, 0.32)' : 'rgba(0, 0, 0, 0.2)'};
  border-radius: 999px;
  color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
  font-size: 0.62rem;
  font-family: ${monoStack};
  letter-spacing: 0.08em;
  cursor: pointer;
  padding: 0.35rem 0.7rem;
  opacity: 0.9;
  line-height: 1;
  box-shadow: inset 0 1px 0
    ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short' ? 'rgba(255, 255, 255, 0.14)' : 'rgba(0, 0, 0, 0.08)'};
  transition:
    transform 0.16s ease,
    opacity 0.2s ease,
    border-color 0.2s ease,
    background 0.2s ease;

  &:hover {
    opacity: 1;
    transform: translateY(-1px);
    border-color: ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.28)'};
    background: ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short'
        ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.08) 100%)'
        : 'linear-gradient(180deg, rgba(0, 0, 0, 0.16) 0%, rgba(0, 0, 0, 0.06) 100%)'};
  }

  &:focus-visible {
    outline: none;
    box-shadow:
      0 0 0 2px ${({ theme }: { theme: ThemeInterface }) =>
        theme.name === 'short' ? 'rgba(255, 255, 255, 0.25)' : 'rgba(0, 0, 0, 0.18)'},
      inset 0 1px 0
        ${({ theme }: { theme: ThemeInterface }) =>
          theme.name === 'short' ? 'rgba(255, 255, 255, 0.14)' : 'rgba(0, 0, 0, 0.08)'};
  }
`;

export const Popover = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 10px;
  background: ${({ theme }: { theme: ThemeInterface }) =>
    theme.name === 'short'
      ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.05) 100%), rgba(0, 0, 255, 0.96)'
      : 'linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.03) 100%), rgba(255, 204, 213, 0.96)'};
  border: 1px solid
    ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)'};
  border-radius: 14px;
  padding: 12px;
  min-width: 220px;
  z-index: 2400;
  font-family: ${monoStack};
  box-shadow:
    inset 0 1px 0
      ${({ theme }: { theme: ThemeInterface }) =>
        theme.name === 'short' ? 'rgba(255, 255, 255, 0.16)' : 'rgba(0, 0, 0, 0.1)'},
    0 18px 38px ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short' ? 'rgba(0, 0, 0, 0.28)' : 'rgba(0, 0, 0, 0.12)'};
  backdrop-filter: blur(7px);
`;

export const TierLabel = styled.div`
  font-size: 0.62rem;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
  opacity: 0.72;
  margin: 0 0 8px;
  padding: 0 2px;
`;

export const PopoverButton = styled.button`
  background: ${({ theme }: { theme: ThemeInterface }) =>
    theme.name === 'short' ? 'rgba(255, 255, 255, 0.07)' : 'rgba(0, 0, 0, 0.06)'};
  border: 1px solid
    ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short' ? 'rgba(255, 255, 255, 0.22)' : 'rgba(0, 0, 0, 0.16)'};
  border-radius: 10px;
  color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
  font-size: 0.63rem;
  font-family: ${monoStack};
  letter-spacing: 0.06em;
  cursor: pointer;
  padding: 0.42rem 0.55rem;
  opacity: 0.88;
  display: block;
  width: 100%;
  text-align: left;
  transition:
    opacity 0.2s ease,
    transform 0.16s ease,
    border-color 0.2s ease;

  &:hover {
    opacity: 1;
    transform: translateY(-1px);
    border-color: ${({ theme }: { theme: ThemeInterface }) =>
      theme.name === 'short' ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.26)'};
  }

  & + & {
    margin-top: 7px;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px
      ${({ theme }: { theme: ThemeInterface }) =>
        theme.name === 'short' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.16)'};
  }
`;

// Upgrade modal (overlay)
export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

export const Card = styled.div`
  background: ${({ theme }) => getOppositeBackground(theme)};
  color: ${({ theme }) => getOppositeText(theme)};
  border: 1px solid ${({ theme }) => theme.primary};
  border-radius: 14px;
  padding: 1.2rem;
  max-width: 360px;
  width: 90%;
  font-family: ${monoStack};
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.24);
`;

export const Title = styled.h2`
  font-size: 0.85rem;
  letter-spacing: 0.1em;
  margin: 0 0 0.5rem 0;
  opacity: 0.9;
`;

export const Description = styled.p`
  font-size: 0.75rem;
  opacity: 0.7;
  line-height: 1.5;
  margin: 0 0 1.25rem 0;
`;

export const ModalActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const ModalButton = styled.button`
  background: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.background};
  border: none;
  padding: 0.6rem 0.75rem;
  font-size: 0.7rem;
  font-family: monospace;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const ModalSecondaryButton = styled.button`
  background: transparent;
  border: 1px solid currentColor;
  color: inherit;
  padding: 0.6rem 0.75rem;
  font-size: 0.7rem;
  font-family: monospace;
  cursor: pointer;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`;

export const Message = styled.p<{ $type?: 'success' | 'error' }>`
  font-size: 0.7rem;
  opacity: ${({ $type }) => ($type ? 1 : 0.6)};
  color: ${({ $type }) =>
    $type === 'success' ? '#22c55e' : $type === 'error' ? '#ef4444' : 'inherit'};
  margin: 0;
`;
